'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _casClient = require('./cas-client');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_casClient).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/auth-client-component/dist/main/index.js
// module id = 109
// module chunks = 0